import {
  Button,
  Datagrid,
  EditButton,
  FunctionField,
  ReferenceManyField,
  TextField,
  usePermissions,
  type RaRecord,
} from "react-admin";
import DownloadIcon from "@mui/icons-material/Download";
import { formatListDate } from "@/utils/date-format";
import { formatINR } from "@/utils/app-formatters";
import { hasPermission } from "@/utils/permission-utils";

const ReceiptEditAction = () => {
  const { permissions } = usePermissions();
  if (!hasPermission(permissions, "sabilReceipts.edit")) {
    return null;
  }
  return <EditButton />;
};

const Receipts = () => {
  const { permissions } = usePermissions();
  const canEdit = hasPermission(permissions, "sabilReceipts.edit");

  const printReceipt = (id: string | number) => {
    window.open(`#/sabil-receipt?receiptId=${id}`, "_blank");
  };
  return (
    <ReferenceManyField reference="sabilReceipt" target="sabilId" label={false}>
      <Datagrid bulkActionButtons={false} rowClick={canEdit ? "edit" : false}>
        <TextField source="receiptNo" label="Receipt No" />
        <FunctionField
          label="Amount"
          sortBy="amount"
          render={(record: RaRecord) => formatINR(record.amount)}
        />
        <FunctionField
          label="Receipt date"
          sortBy="receiptDate"
          render={(record: RaRecord) => formatListDate(record?.receiptDate, { empty: "—" })}
        />
        <TextField source="paymentMode" label="Payment mode" emptyText="—" />
        <TextField source="remarks" emptyText="—" />
        <FunctionField
          label="Download"
          source="formNo"
          render={(record) => (
            <Button onClick={() => printReceipt(record.id)}>
              <DownloadIcon />
            </Button>
          )}
        />
        <ReceiptEditAction />
      </Datagrid>
    </ReferenceManyField>
  );
};

export default Receipts;
